import { Controller } from "@hotwired/stimulus"

export default class extends Controller {
  static targets = ["addressForm", "hiddenField"]

  declare readonly addressFormTarget: HTMLElement
  declare readonly hiddenFieldTarget: HTMLInputElement

  connect() {
    // Initialize the form visibility based on checkbox state
    this.toggleForm()
  }

  toggleForm() {
    const checkbox = this.element.querySelector('#use_organization_address') as HTMLInputElement
    
    if (!checkbox || !this.addressFormTarget || !this.hiddenFieldTarget) return

    if (checkbox.checked) {
      // Hide the address form
      this.addressFormTarget.style.display = 'none'
      this.hiddenFieldTarget.value = '1'
    } else {
      // Show the address form
      this.addressFormTarget.style.display = 'block'
      this.hiddenFieldTarget.value = '0'
    }
  }
}
